<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <h3 class="mb-0">Users</h3>
      </b-card-header>
      <b-table responsive small :items="users" :fields="fields" :per-page="0" :currentPage="pagination.currentPage" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true" @sort-changed="sortItems">
        <template #table-busy>
          <loading-panel></loading-panel>
        </template>
        <template #cell(actions)="row">
          <b-dropdown size="sm" variant="primary" id="actions" text="Actions" class="m-md-2">
              <b-dropdown-item :to="'/observatory/' + row.item.slug + '/dashboard'">View Portal</b-dropdown-item>
              <b-dropdown-item @click="deactivateUser(row.item.email)">Deactivate User</b-dropdown-item>
            </b-dropdown>
        </template>

      </b-table>
      <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class="">
          <p class="card-category">
            Showing {{ pagination.from + 1 }} to {{ pagination.to }} of {{ pagination.total }} entries

            <span v-if="selectedRows.length">
              &nbsp; &nbsp; {{selectedRows.length}} rows selected
            </span>
          </p>

        </div>
        <base-pagination
          class="pagination-no-border"
          :current="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
          @change="paginationChanged($event)"
        >
        </base-pagination>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import paginationMixin from '@/views/Components/Tables/PaginatedTables/paginationMixin';
import errorsMixin from '@/mixins/errors-mixin.js';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import LoadingPanel from '@/components/LoadingPanel';

export default {
  mixins: [errorsMixin, paginationMixin],
  props: {
    enterprise: null
  },
  components: {
    LoadingPanel
  },
  data() {
    return {
      users: null,
      selectedRows: [],
      propsToSearch: [],
      sortBy: 'name',
      sortDesc: false,
      fields: [
        {
          key: 'actions',
          sortable: false
        },
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'email',
          sortable: true
        },
        {
          key: 'phone',
          sortable: false
        }
      ],
      isBusy: false,
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      observedRoute: 'observed/observedRoute',
    }),
    getRoute() {
      return this.$route.params.user ? this.observedRoute : this.userRoute;
    }
  },
  methods: {
    async getUsers() {
      this.isBusy = true;
      const params = "?page=" + this.pagination.currentPage + "&perPage=" + this.pagination.perPage + "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc + "&searchQuery=" + this.searchQuery;

      await axios.get(this.getRoute + "/enterprises/" + this.enterprise.slug + "/users" + params)
      .then(response => {
        this.users = response.data.data;
        this.pagination.total = response.data.meta.total;
        this.pagination.from = response.data.meta.from;
        this.pagination.to = response.data.meta.to;
        this.isBusy = false;
      })
      .catch(error => {
        this.error(error);
      });
    },
    paginationChanged(page) {
      this.pagination.currentPage = page;
    },
    deactivateUser(email) {
      swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, deactivate User!',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deactivate(email);
        }
      });
    },
    async deactivate(email) {
      await axios.post(this.getRoute + "/enterprises/" + this.enterprise.slug + "/users/deactivate", {
        email: email
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.getUsers();
        });
      })
      .catch(error => {
        this.error(error);
      });
    }
  },
  watch: {
    enterprise(to, from) {
      this.getUsers();
    },
    'pagination.currentPage'(to, from) {
      this.getUsers();
    },
    'pagination.perPage'(to, from) {
      this.getUsers();
    },
    role(to, from) {
      this.getUsers();
    },
    realtyRole(to, from) {
      this.getUsers();
    },
    searchQuery(to, from) {
      this.getUsers();
    }
  }
};
</script>